<template>
  <div class="modal-overlay">
    <div class="modal-content" style="max-width: 40vw">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ user_id ? "✏️ Edit System User" : "➕ Add New System User" }}
        </h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <div class="modal-body">
        <div class="form-group">
          <label>Full Name:</label>
          <input
            type="text"
            v-model="user.name"
            placeholder="Enter full name"
          />
        </div>

        <div class="form-group">
          <label>Email:</label>
          <input
            type="email"
            v-model="user.email"
            placeholder="Enter email address"
          />
        </div>

        <div class="form-group">
          <label>Phone:</label>
          <input
            type="text"
            v-model="user.phone"
            placeholder="Enter phone number"
          />
        </div>

        <div class="form-group">
          <label>Role:</label>
          <select v-model="user.role_id">
            <option disabled value="">-- Select Role --</option>
            <option v-for="role in roles" :key="role.id" :value="role.id">
              {{ role.name }}
            </option>
          </select>
        </div>

        <div class="form-group" v-if="!user_id">
          <label>Password:</label>
          <input
            type="password"
            v-model="user.password"
            placeholder="Enter password"
          />
        </div>

        <div class="form-group" v-if="!user_id">
          <label>Confirm Password:</label>
          <input
            type="password"
            v-model="confirmPassword"
            placeholder="Confirm password"
          />
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-cancel" @click="closeModal">
          Cancel
        </button>
        <button type="button" class="btn btn-save" @click="saveUser">
          {{ user_id ? "Update User" : "Save User" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
export default {
  name: "AddEditUserModal",
  props: {
    user_id: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      user: {
        name: "",
        email: "",
        phone: "",
        role_id: "",
        password: "",
      },
      confirmPassword: "",
      roles: [],
    };
  },
  methods: {
    async getRoles() {
      const url = "roles/get";
      const body = {};
      const rs = await generalApiRequest(url, "GET", body, 1);
      this.roles = rs.data;
    },
    closeModal() {
      this.$emit("close-add-sys-user-mod");
    },
    async saveUser() {
      if (!this.user.name || !this.user.email || !this.user.role_id) {
        alert("Please fill in all required fields.");
        return;
      }
      if (!this.user_id && this.user.password !== this.confirmPassword) {
        alert("Passwords do not match.");
        return;
      }
      console.log(this.user);
      const url = this.user_id ? "updateSystemUser" : "storeSystemUser";
      const body = {
        id: this.user.id,
        name: this.user.name,
        email: this.user.email,
        phone: this.user.phone,
        role_id: this.user.role_id,
        password: this.user.password,
      };
      const rs = await generalApiRequest(url, "POST", body, 1);
      this.roles = rs.data;

      this.closeModal();
    },
    async fetchUserDetails() {
      const url = "system_users/getbyid/" + this.user_id;
      const body = {};
      const rs = await generalApiRequest(url, "GET", body, 1);

      // console.log(rs);

      this.user.id = this.user_id;
      this.user.name = rs.data.name;
      this.user.email = rs.data.email;
      this.user.phone = rs.data.phone;
      this.user.role_id = rs.data.role_id;
    },
  },
  mounted() {
    this.getRoles();
    if (this.user_id) {
      this.fetchUserDetails();
    }
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  border-radius: 0.4rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: #f5f5f5;
  border-bottom: 1px solid #ddd;
}

.modal-title {
  font-size: 1.2rem;
}

.close {
  background: #e31919;
  color: #fff;
  border: none;
  font-size: 1.3rem;
  line-height: 1;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
}

.modal-body {
  padding: 1rem;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  font-weight: 600;
  margin-bottom: 0.4rem;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #bbb;
  border-radius: 0.3rem;
  font-size: 0.95rem;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 0.8rem 1rem;
  border-top: 1px solid #ddd;
}

.btn-save {
  background: #2786f7;
  color: #fff;
  padding: 0.45rem 1rem;
  border: none;
  border-radius: 0.3rem;
  margin-left: 0.5rem;
  cursor: pointer;
}

.btn-cancel {
  background: #aaa;
  color: #fff;
  padding: 0.45rem 1rem;
  border: none;
  border-radius: 0.3rem;
  cursor: pointer;
}
</style>
